import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./ViewBookings.scss";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { GetSessionStorageData } from "../../../../Services/Helpers/Helper";
import {
  API_RESPONSE,
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  STORAGE_KEYS,
  TOASTER_CONFIGS,
} from "../../../../Utilities/Constants/Constants";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { useTranslation } from "react-i18next";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Card, Tooltip } from "@mui/material";
import BackArrow from "../../../../../Assets/schools/back_button.svg";
import videoIcon from "../../../../../Assets/Sessions/video_call_icon.svg"
import { toast } from "react-toastify";
import profileDefault from "../../../../../Assets/global/profile_default.svg";

const ViewBookings = () => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const { id } = useParams();
  const navigate = useNavigate();
  const route = useLocation();
  const [roleId, setRoleId] = useState("");
  const [myEventsList, setMyEventsList] = useState<any>([]);
  const localizer = momentLocalizer(moment);
  const [selectedDate, setSelectedDate] = useState<any>();
  const [selectedData, setSelectedData] = useState<any>();
  const [loopIndex, setLoopIndex] = useState(0);
  const [startDate, setStartDate] = useState("");

  /* Getting Role Id from session storage */
  useEffect(() => {
    setRoleId(GetSessionStorageData(STORAGE_KEYS.ROLE) || "");
  }, []);

  /* Calling booking detail api on role id update */
  useEffect(() => {
    if (roleId) getBookingData();
  }, [roleId]);

  const onDoubleClick = () => { };

  const onSelecting = () => { };

  /* Formatting response as per calender requirements */
  const formatEvents = (data: any) => {
    const format = data.map((date: any) => {
      return {
        // start: moment(date.start).toDate(),
        // end: moment(date.end).toDate(),
        start: new Date(date.start),
        end: new Date(date.end),
        title: date.title,
        slot_id: date.session_slot,
        timeslot_id: date.id,
        free_session: date.is_free_session,
        service_session_id: date.service_provider_id,
        teach_service: date.teach_service_provider_id,
        child_profile: date?.child_profile,
        username: date?.username,
        course_mode: date?.course_mode,
        session_slot: date?.session_slot,
        id: date?.id,
        meet_link: date?.meet_link
      };
    });
    setMyEventsList(format);
  };


  /* Booking detail API call */
  const getBookingData = () => {
    let payload = {
      service_provider_id: id,
      teach_service_provider:
        roleId === `${NUMBER_CONSTANTS.FOUR}`
          ? NUMBER_CONSTANTS.ONE
          : `${NUMBER_CONSTANTS.NINE}`
            ? NUMBER_CONSTANTS.TWO
            : NUMBER_CONSTANTS.THREE,
    };
    axiosInstance
      .post(API_END_POINTS.BOOKING_DETAILS, payload)
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          // setMyEventsList(response.data.result.data);
          console.log(response.data.result.data, '------')
          formatEvents(response.data.result.data);
          if (route?.state?.notification_redirect && route?.state?.notification_redirect_Detailes?.date) {
            setSelectedDate(new Date(route?.state?.notification_redirect_Detailes?.date));
            const filteredEvents = response.data.result.data?.filter((item: any) => {
              return (
                moment(item?.start).format(COMMON_CONSTANTS.DMY_FORMAT) ===
                moment(route?.state?.notification_redirect_Detailes?.date).format(COMMON_CONSTANTS.DMY_FORMAT)
              );
            });
            setSelectedData(filteredEvents);
          }
        }
      });
  };

  /* Setting start date */
  const setDate = (date: any) => {
    setStartDate(moment(date).local().format(COMMON_CONSTANTS.MDY_FORMAT));
  };

  /* Event component for rendering with time */
  const eventPropsRender = (event: any) => {
    return <p className="event-title">{event.title}</p>;
  };

  /* Adding classname on click date */
  const onSelectDate: any = (date: any) => {
    return (
      moment(date).format(COMMON_CONSTANTS.DMY_FORMAT) ===
      moment(startDate).format(COMMON_CONSTANTS.DMY_FORMAT) && {
        className: "rbc-selected-day",
      }
    );
  };

  /* Handling date select */
  const handleDateSelect = (selectInfo: any) => {
    setSelectedDate(new Date(selectInfo.start));
    const filteredEvents = myEventsList?.filter((item: any) => {
      return (
        moment(item?.start).format(COMMON_CONSTANTS.DMY_FORMAT) ===
        moment(selectInfo.start).format(COMMON_CONSTANTS.DMY_FORMAT)
      );
    });
    setSelectedData(filteredEvents);
  };

  /* Rendering calender function */
  const renderCalendar = () => {
    moment.locale('en');

    return (
      <Calendar
        selectable
        localizer={localizer}
        events={myEventsList}
        onDoubleClickEvent={onDoubleClick}
        onView={onSelecting}
        onSelectSlot={(e: any) => {
          setLoopIndex(NUMBER_CONSTANTS.ZERO)
          setDate(e.start);
          handleDateSelect(e);
        }}
        defaultDate={route?.state?.notification_redirect ? new Date(route?.state?.notification_redirect_Detailes?.date) : new Date()}
        onKeyPressEvent={() => { }}
        onSelectEvent={(event: any) => {
          setLoopIndex(NUMBER_CONSTANTS.ZERO)
          setDate(event.start);
          onSelectDate(event);
          handleDateSelect(event);
        }}
        showMultiDayTimes={true}
        dayPropGetter={(e: any) => onSelectDate(e)}
        components={{
          event: eventPropsRender,
        }}
      />
    );
  };

  const checkEnableTime = (timing: any) => {
    const currentTime = new Date();
    const startTime = new Date(timing.start);

    // Calculate the timestamp for 5 minutes before the start time
    const fiveMinutesBeforeStartTime = new Date(startTime.getTime() - NUMBER_CONSTANTS.FIFTEEN * NUMBER_CONSTANTS.SIXTY * NUMBER_CONSTANTS.THOUSAND);

    // Check if the current time is less than 5 minutes before the start time
    if (currentTime >= fiveMinutesBeforeStartTime) {
      return API_RESPONSE.TRUE;
    } else {
      return API_RESPONSE.FALSE;
    }
  };

  const enableAttendence = (data: any) => {
    console.log(data, 'attendence')
    axiosInstance
      .put(API_END_POINTS.ENABLE_ATTENDENCE, {
        "session_time_slot_id": data.id,
        "session_slot_id": data.session_slot,
      })
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          // toast.success(response.data.message, TOASTER_CONFIGS);
          window.open(data?.meet_link, '_blank')
        }
      });

  };


  return (
    <div className="calender-bookings-wrapper">
      <div className="arrow-wrap">
        <img
          alt="Learn and Play"
          src={BackArrow}
          className="EditSchool-backarrow"
          onClick={() => {
            navigate(-1);
          }}
        />
        <h5 className="name-title ms-2">{t("Bookings Detail")}</h5>
      </div>

      <div className="row">
        <div className="col-md-8">{renderCalendar()}</div>
        <div className="col-md-4">
          <div className="booking-details">
            <div className="title-wrapper">
              <p>{moment(selectedDate).format("dddd Do MMMM, YYYY")}</p>
            </div>
            <div className="time-switch-wrap">
              {selectedData?.length > 0 && (
                <div>
                  <div className="time-switcher">
                    <div className="time-wrapper">
                      {loopIndex > 0 && (
                        <Tooltip title="Prev">
                          <ArrowLeftIcon
                            className="arrow-icon-left"
                            onClick={() => {
                              setLoopIndex(loopIndex - 1);
                            }}
                          />
                        </Tooltip>
                      )}
                      {moment(selectedData[loopIndex].start).format("hh:mm A")}-
                      {moment(selectedData[loopIndex].end).format("hh:mm A")}
                      {loopIndex + 1 < selectedData.length && (
                        <Tooltip title="Next">
                          <ArrowRightIcon
                            className="arrow-icon-right"
                            onClick={() => {
                              setLoopIndex(loopIndex + 1);
                            }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div className="booked-list-wrapper">
                    {selectedData.map((data: any, index: any) => {
                      return (
                        <>
                          <Card className="booking-detail-card">
                            <div className="approval-label">
                              {data?.course_mode === "offline" ? "On-Premises" : data.course_mode}
                            </div>
                            {roleId === `${NUMBER_CONSTANTS.FOUR}` && data.course_mode === "Online" && data.is_meet_link && <img src={videoIcon} className="video-icon" onClick={() => {
                              enableAttendence(data);
                            }} />}
                            <p className="session-title">{data?.title}</p>



                            <div className="user-data-wrap">
                              <img
                                className="user-profile"
                                src={
                                  data?.child_profile
                                    ? data?.child_profile
                                    : profileDefault
                                }
                                onError={(e: any) => e.target.src = profileDefault}
                              />
                              <div className="name-wrap">
                                <p>{data?.username}</p>
                                <>{roleId === `${NUMBER_CONSTANTS.FOUR}` && <p className="cell-value">{t(data?.is_didnot ? (moment(new Date(data?.start)).format(COMMON_CONSTANTS.YMD_FORMAT) < moment(new Date()).format(COMMON_CONSTANTS.YMD_FORMAT) ? 'Did not attend' : 'Will not attend') : moment(new Date(data?.start)).format(COMMON_CONSTANTS.YMD_FORMAT) < moment(new Date()).format(COMMON_CONSTANTS.YMD_FORMAT) ? 'Attended' : 'Will attend')}</p>}</>
                              </div>
                            </div>
                          </Card>
                        </>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBookings;
